import { Configuration } from './../../models/configuration.model';
import { LoginService } from '../../services/login.service';

import {of as observableOf,  Observable ,  Subscription } from 'rxjs';
import { filter, switchMap, tap,  map } from 'rxjs/operators';
import { UserService } from './../../services/user.service';
import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { User, RoleType, BusinessUnit } from '../../models/identity';
import { Router, ActivatedRoute, NavigationEnd, ParamMap, ActivatedRouteSnapshot } from '@angular/router';
import { ProcessParticipationApprovalRequirementType } from '../../models/process-models';
import { NamedEntity } from '../../models/named-entity.model';
import { BusinessUnitService } from '../../services/business-unit.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationRespondentService } from '../../services/confirmation-respondent.service';
import { AuthType } from '../../models/auth.enum';

@Component({
    selector: 'app-usermenu',
    templateUrl: './usermenu.component.html',
    styleUrls: ['./usermenu.component.scss']
})
export class UsermenuComponent implements OnInit, OnDestroy {

    @Input() isAdminRoute: boolean;
    @Input() currentUser: User;
    currentUserTeam$: Observable<Array<NamedEntity>>;
    employeeBusinessUnits$: Observable<Array<BusinessUnit>>;
    currentYear: number;
    defaultPhoto: string = '../../../assets/images/placeholder_avatar.png';
    requirementType: any = ProcessParticipationApprovalRequirementType;
    isCollapsedMyTeam = true;
    isCollapsedMyBu = true;
    isMyBuSurveyTab = false;
    isMyTeamSurveyTab = false;
    activeTeamMateId: number;
    activeBusinessUnitId: number;
    account: any;
    avatar$: Observable<any>;

    private subscriptions = new Subscription();
    private readonly decimailScale = 10;
    constructor(private readonly configService: ConfigService,
        private readonly userService: UserService,
        private readonly businessUnitService: BusinessUnitService,
        private readonly translateService: TranslateService,
        private readonly confirmationService: ConfirmationRespondentService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly ref: ChangeDetectorRef,
        private readonly loginService: LoginService
        ) { }

    ngOnInit() {
        const configuration = this.configService.configData as Configuration;
        if(!this.loginService.getUser) {
          return;
        }
        
        if (configuration.authenticationType == AuthType.Graph) {
          this.loginService.employeeLoggedIn.subscribe(c => this.setCurrent());
        }
  
        this.setCurrent();
        this.currentYear = new Date().getFullYear();
        
        this.currentUser = this.loginService.getUser;
        if (this.currentUser != null) {
            this.avatar$ = this.userService.getAvatar(this.currentUser.id);
            this.currentUserTeam$ = this.userService.getTeam();
            this.employeeBusinessUnits$ = this.businessUnitService.getEmployeeBusinessUnits();
        }
        this.subscriptions = this.confirmationService.myBuSurveyTabClicked$
            .subscribe(x => {
                this.isMyBuSurveyTab = x;
                this.ref.detectChanges();
            });
            this.setCurrentSubmenuItem();
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }

    toggleUserMenu() {
        this.isAdminRoute = !this.isAdminRoute;
        (this.isAdminRoute) ?
            this.router.navigateByUrl('admin/processes-list') :
            this.router.navigateByUrl('user/survey-list');
    }

    hasAccessToAdminMenu() {
        return this.currentUser.roles.some(x => {
            return x === RoleType.SuperAdministrator;
        });
    }

    getDesignedByFooter() {
        return this.translateService.get('lang.common.designedByFooter');
    }

    getFooter() {
        const year = new Date().getFullYear().toString();
        let policy = '';
        return this.translateService.get('lang.common.intranetPolicyLink').pipe(
            switchMap(x => {
                policy = x;
                return this.translateService.get('lang.common.footer');
            }),
            map(x => (x as string).replace('[intranetPolicyLink]', policy).replace('[currentYear]', year)),);
    }

    sortByName(names: Array<NamedEntity>): Array<NamedEntity> {
        return names.sort((a, b) => a.name.localeCompare(b.name));
    }

    sortByDisplayName(names: Array<BusinessUnit>): Array<BusinessUnit> {
        return names.sort((a, b) => a.displayName.localeCompare(b.displayName));
    }

    logout() {
        this.loginService.logout();
    }

    private setCurrentSubmenuItem() {
        this.router.events.pipe(
            filter(x => x['state'] && x['state'].root && x['state'].root.children),
            map(x => {
                const childrenRoute: ActivatedRoute = [...x['state'].root.children].shift();
                return (childrenRoute && childrenRoute.firstChild) ? childrenRoute.firstChild : observableOf({});
            }), 
        )
        .subscribe((x: any) => {
            this.activeTeamMateId = NaN;
            this.activeBusinessUnitId = NaN;
            if (x['params']) {
             const object =   this.getRouteParams(x['params']);
             this.showHideMenuItem(object);
            }
        });
    }

    private getRouteParams(params: any): { teammateEmployeeId: string, businessUnitId: string } {
        const teammateEmployeeId = (params['teammateEmployeeId']) ? params['teammateEmployeeId'] : '';
        const businessUnitId = (params['businessUnitId']) ? params['businessUnitId'] : '';
        const object =  Object.assign({}, {teammateEmployeeId: teammateEmployeeId,
            businessUnitId: businessUnitId }
            );
            return object;
    }

    private showHideMenuItem(object: { teammateEmployeeId: string, businessUnitId: string }) {
        this.activeTeamMateId = parseInt(object.teammateEmployeeId, this.decimailScale);
        this.activeBusinessUnitId = parseInt(object.businessUnitId, this.decimailScale);
        this.isCollapsedMyTeam = (isNaN(this.activeTeamMateId)) ? this.isCollapsedMyTeam : false;
        this.isCollapsedMyBu = (isNaN(this.activeBusinessUnitId)) ? this.isCollapsedMyBu : false;
    }

    private setCurrent() {
        this.currentUser = this.loginService.getCurrent();
        if (this.configService.configData.authenticationType != 1) return;
        this.account = this.loginService.getAccount();
      }
}